import React, { useEffect, useState } from 'react'
import './projects.css'
import { getPortfolioConfig } from '../../firebase'

const Projects = () => {
  const [selectedProject, setSelectedProject] = useState(null)
  const [projects, setProjects] = useState([])

  useEffect(() => {
    let isMounted = true

    const loadProjects = async () => {
      const { projects: remoteProjects } = await getPortfolioConfig()

      if (isMounted) {
        setProjects(remoteProjects)
      }
    }

    loadProjects()

    return () => {
      isMounted = false
    }
  }, [])

  const openModal = (id) => {
    setSelectedProject(projects.find((p) => p.id === id))
    document.body.style.overflow = 'hidden'
  }

  const closeModal = () => {
    setSelectedProject(null)
    document.body.style.overflow = 'unset'
  }

  return (
    <>
      <section id="projects" className='card-container'>
        <h5>Highlighted Work</h5>
        <h2>Projects</h2>

        <div className="container projects__container">
          <div className="projects__grid">
            {projects.length > 0 ? projects.map((project) => {
              const technologies = Array.isArray(project.technologies) ? project.technologies : []
              const highlights = Array.isArray(project.highlights) ? project.highlights : []

              return (
                <div key={project.id} className="projects__card">
                  <div className="projects__card-header">
                    <div className="projects__title-group">
                      <h3>{project.title}</h3>
                      <p className="projects__subtitle">{project.subtitle}</p>
                    </div>
                    <button
                      className="projects__expand-btn"
                      onClick={() => openModal(project.id)}
                      aria-label="View project details"
                      title="View details"
                    >
                      ⋯
                    </button>
                  </div>

                  <div className="projects__tech-stack">
                    {technologies.map((tech, idx) => (
                      <span key={idx} className="tech-badge">{tech}</span>
                    ))}
                  </div>

                  <div className="projects__highlights">
                    <ul>
                      {highlights.map((highlight, idx) => (
                        <li key={idx}>{highlight}</li>
                      ))}
                    </ul>
                  </div>

                  <div className="projects__footer">
                    <div className="projects__links">
                      {project.links?.code && (
                        <a target="_blank" href={project.links.code} className="project-link code-link" title="View Source Code" rel="noreferrer">
                          <span className="link-icon">{'</>'}</span> Code
                        </a>
                      )}
                      {project.links?.demo && (
                        <a target="_blank" href={project.links.demo} className="project-link demo-link" title="View Live Demo" rel="noreferrer">
                          <span className="link-icon">→</span> Demo
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              )
            }) : (
              <p className="text-light">Project data is loading...</p>
            )}
          </div>
        </div>
        <p className="projects__scroll-hint" aria-hidden="true">Swipe to explore projects <span>→</span></p>
      </section>

      {selectedProject && (
        <div className="projects__modal-overlay" onClick={closeModal}>
          <div className="projects__modal" onClick={(e) => e.stopPropagation()}>
            <button className="projects__modal-close" onClick={closeModal} aria-label="Close modal">×</button>

            <div className="projects__modal-header">
              <h2>{selectedProject.title}</h2>
              <p className="projects__modal-subtitle">{selectedProject.subtitle}</p>
            </div>

            <div className="projects__modal-tech">
              {(Array.isArray(selectedProject.technologies) ? selectedProject.technologies : []).map((tech, idx) => (
                <span key={idx} className="tech-badge">{tech}</span>
              ))}
            </div>

            <div className="projects__modal-achievements">
              <h4>Project Details</h4>
              <ul>
                {(Array.isArray(selectedProject.fullAchievements) ? selectedProject.fullAchievements : []).map((achievement, idx) => (
                  <li key={idx}>{achievement}</li>
                ))}
              </ul>
            </div>

            <div className="projects__modal-footer">
              <div className="projects__modal-links">
                {selectedProject.links?.code && (
                  <a href={selectedProject.links.code} className="project-link code-link" title="View Source Code" target="_blank" rel="noopener noreferrer">
                    <span className="link-icon">{'</>'}</span> Code
                  </a>
                )}
                {selectedProject.links?.demo && (
                  <a href={selectedProject.links.demo} className="project-link demo-link" title="View Live Demo" target="_blank" rel="noopener noreferrer">
                    <span className="link-icon">→</span> Demo
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Projects
